import vcService from '@/services/vcservice.service'

const actions = {
  fetchVirtualCurrency({ commit }, { patientId }) {
    return vcService.fetchVCByPatientId({ patientId })
      .then((data) => {
        return data.data;
      })
  },


  transferVCSerivce({commit}, { payload}) {
    return vcService.transferVirtualCurrency({ payload })
      .then(data => data);
  }
}

export default {
  namespaced: true,
  actions
}